
export function isDefined(obj: unknown): boolean {
  return obj !== undefined && obj !== null;
}

export function isEmptyString(obj: unknown): boolean {
  return !isDefined(obj) || obj === "";
}
